import { render, staticRenderFns } from "./CallItem.vue?vue&type=template&id=9108f8ec&scoped=true"
import script from "./CallItem.vue?vue&type=script&lang=js"
export * from "./CallItem.vue?vue&type=script&lang=js"
import style0 from "./CallItem.vue?vue&type=style&index=0&id=9108f8ec&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9108f8ec",
  null
  
)

export default component.exports